import { render } from "./AgregarSeguimientoPage.vue?vue&type=template&id=06dccdaa"
import script from "./AgregarSeguimientoPage.vue?vue&type=script&lang=js"
export * from "./AgregarSeguimientoPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__